if (!customElements.get('bts-option-b')) {
  class BTSOptionB extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.addEventListener('click', (event) => {
        const productTab = event.target.closest('[data-bts-tab]');
        if (productTab && this.contains(productTab)) {
          this.activateTab(productTab, '[data-bts-tab]', '[data-bts-panel]', 'data-bts-tab', 'data-bts-panel');
          return;
        }

        const routineTab = event.target.closest('[data-bts-routine-tab]');
        if (routineTab && this.contains(routineTab)) {
          this.activateTab(
            routineTab,
            '[data-bts-routine-tab]',
            '[data-bts-routine-panel]',
            'data-bts-routine-tab',
            'data-bts-routine-panel'
          );
        }
      });

      this.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const current = event.target.closest('[role="tab"]');
        if (!current || !this.contains(current)) return;

        const tablist = current.closest('[role="tablist"]');
        if (!tablist) return;
        const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
        const currentIndex = tabs.indexOf(current);
        if (currentIndex < 0) return;

        event.preventDefault();
        let nextIndex = currentIndex;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        tabs[nextIndex].focus();
        tabs[nextIndex].click();
      });
    }

    activateTab(activeTab, tabSelector, panelSelector, tabAttribute, panelAttribute) {
      const id = activeTab.getAttribute(tabAttribute);
      const tablist = activeTab.closest('[role="tablist"]');
      const scope = tablist && tablist.parentElement ? tablist.parentElement : this;

      scope.querySelectorAll(tabSelector).forEach((tab) => {
        const selected = tab === activeTab;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });

      scope.querySelectorAll(panelSelector).forEach((panel) => {
        const selected = panel.getAttribute(panelAttribute) === id;
        panel.classList.toggle('is-active', selected);
        panel.hidden = !selected;
      });
    }
  }

  customElements.define('bts-option-b', BTSOptionB);
}
